import { render, staticRenderFns } from "./EditSeguroiparcelamentoPage.vue?vue&type=template&id=35fa9c86&"
import script from "./EditSeguroiparcelamentoPage.vue?vue&type=script&lang=js&"
export * from "./EditSeguroiparcelamentoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports